import { render } from "./BaseLayout.vue?vue&type=template&id=6382428c&ts=true"
import script from "./BaseLayout.vue?vue&type=script&lang=ts"
export * from "./BaseLayout.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/anteup/anteup-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__